import React, { useState } from 'react';
import { mapIndividualSummaryData } from '../utils';
import AccordionItem from './AccordionItem';
import { useTranslations } from '../../context/TranslationContext';

const IndividualEvaluations = ({ summary: data }) => {
    const { t } = useTranslations();
    const [toggleState, setToggleState] = useState({ 0: true });

    const records = Object.values(data);

    const toggleAccordion = (index) => {
        setToggleState((prevState) => ({ ...prevState, [index]: !prevState[index] }));
    };

    return (
        <div className='candidate-accordion'>
            {records.length === 0 && (
                <h6 className='no-data-placeholder'>{t('No evaluations')}</h6>
            )}
            {records.map(({ name, ...summary }, index) => {
                const [overallScore, ...items] = mapIndividualSummaryData(summary.items);

                return (
                    <AccordionItem
                        key={index}
                        index={index}
                        name={name}
                        items={items}
                        overallScore={overallScore}
                        toggleState={toggleState[index]}
                        toggleAccordion={toggleAccordion}
                    />
                );
            })}
        </div>
    );
};

export default IndividualEvaluations;
